/**
 * Enum for column headers used to import voluntary compliance dates by csv.
 * NB: Same as in VoluntaryComplianceCSVImport.php! Keep in sync.
 */
export enum VoluntaryComplianceCSVImport {
  'CASE_NUMBER' = 'toimiku_nr',
  'VOLUNTARY_COMPLIANCE_DATE' = 'vabatahtliku_taitmise_kp',
}
